import { createContext, useMemo } from "react";

import { useAttachmentsData } from "@RequestFormV2/sections/Attachments/context/useAttachmentsData";
import { useProviderHandlers } from "@RequestFormV2/sections/Provider/context/useProviderHandlers";

type AttachmentsContextType = ReturnType<typeof useAttachmentsData> &
  Pick<
    ReturnType<typeof useProviderHandlers>,
    | "handleAddBucketFile"
    | "handleDeleteBucketFile"
    | "handleAppendBucketAttachments"
    | "handleRemoveBucketFileByRef"
    | "handleAppendOtherAttachments"
    | "handleRemoveOtherFile"
  >;

const AttachmentsContext = createContext<AttachmentsContextType | null>(null);

function AttachmentsProvider({ children }: { children: React.ReactNode }) {
  const data = useAttachmentsData();
  const {
    handleAddBucketFile,
    handleDeleteBucketFile,
    handleAppendBucketAttachments,
    handleRemoveBucketFileByRef,
    handleAppendOtherAttachments,
    handleRemoveOtherFile,
  } = useProviderHandlers();

  const value = useMemo(
    () => ({
      ...data,
      handleAddBucketFile,
      handleDeleteBucketFile,
      handleAppendBucketAttachments,
      handleRemoveBucketFileByRef,
      handleAppendOtherAttachments,
      handleRemoveOtherFile,
    }),
    [
      data,
      handleAddBucketFile,
      handleDeleteBucketFile,
      handleAppendBucketAttachments,
      handleRemoveBucketFileByRef,
      handleAppendOtherAttachments,
      handleRemoveOtherFile,
    ],
  );

  return <AttachmentsContext.Provider value={value}>{children}</AttachmentsContext.Provider>;
}

export { AttachmentsContext, AttachmentsProvider };
